module.exports = __webpack_public_path__ + "static/media/facebook.f8f58cf3.png";